import { render, staticRenderFns } from "./BaseError.vue?vue&type=template&id=23db213a&scoped=true&"
import script from "./BaseError.vue?vue&type=script&lang=js&"
export * from "./BaseError.vue?vue&type=script&lang=js&"
import style0 from "./BaseError.vue?vue&type=style&index=0&id=23db213a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23db213a",
  null
  
)

export default component.exports
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBanner,QIcon});
